import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'CS',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      EN: {
        translation: {
          common_name: 'Name',
          common_weight: 'Weight',
          common_density: 'Density',
          common_energy: 'Energy',
          common_protein: 'Protein',
          common_carbohydrate: 'Carbohydrate',
          common_fat: 'Fat',
          common_fiber: 'Fiber',
          common_total: 'Total',
          common_add: 'Add',
          common_save: 'Save',
          login: {
            welcome_message_heading: 'Welcome! Plan your meals the easy way',
            welcome_message_description: 'Set your goals, keep track of them, and enjoy recipes made just for your preferences and lifestyle. Get helpful tips, delicious recipes, and instant meal plans start right now!',
            username: 'Username',
            password: 'Password',
            login: 'Log In',
            start_onboarding: 'Create Plan',
            newsletter: 'Enter your email to subscribe to our newsletter'
          },
          onboarding_dashboard: {
            header: 'Welcome to Your Personalized Dashboard',
            subheader: "Based on your information, we've calculated these daily targets to help you reach your goal BMI.",
            primary_cta: 'View recommended meals',
            health_overview: {
              label: 'Health Overview',
              bmi: 'BMI',
              goal: 'Goal',
              daily_calories: 'Daily calories',
              weight: 'Current weight'
            },
            motivational_message: 'You’re on track to achieve your health goals!',
            cta_message: 'Want to save your personalized plan and track your progress?',
            nutritional_goals: 'Nutritional goals',
            recommended_meals: {
              label: 'Recommended Meals',
              header: 'These meals have been carefully calculated to meet your daily targets.'
            }
          },
          signup_section: {
            your_email: 'Your email',
            password: {
              password: 'Password',
              password_strength: 'Password Strength',
              very_weak: "Very Weak",
              weak: "Weak",
              medium: "Medium",
              strong: "Strong",
              very_strong: "Very Strong",
            },
            submitting: 'Submitting...',
            save_my_progress: 'Save my progress'
          },
          onboarding: {
            stepper: {
              STEP1: 'Body details',
              STEP2: 'Lifestyle',
              STEP3: 'Preferences'
            },
            tooltip: {
              sex: 'Your biological sex helps us provide accurate calorie estimates tailored to your needs. Please select the option that best aligns with you biologically.',
              preferred_languages: 'Priority matters; the first selected is highest priority, and so on.'
            },
            step1_helper: 'We use these details to calculate daily intake and portions. You can change them anytime.',
            step1_motivation: 'We will help you reach your target weight at a healthy pace.',
            validation_required: 'Please fill in all required fields.',
            step1_weight_change_limit_exceeded: "Weight change between current and target cannot exceed 10 kg.",
    target_date: 'By when would you like to reach your goals?',
    current_bmi: 'Current BMI',
    target_bmi: 'Target BMI',
    step1_target_date_past_error: 'Target date cannot be in the past.',
    unhealthy_pace_warning: 'With this target date, your plan would require a very fast weight change (about more than 0.75 kg/week). A healthier pace is recommended. Try reaching your goal by {{recommendedDate}}.',
    use_recommended_target_date: 'Use recommended date',
            current_weight: 'Current weight (kg)',
            target_weight: 'Target weight (kg)',
            height: 'Height (cm)',
            age: 'Age',
            activity_level: {
              label: 'Activity level',
              SEDENTARY: 'Sedentary',
              sedentary_descritption: 'Minimal daily movement',
              MODERATELY_ACTIVE: 'Moderately Active',
              moderately_active_descritption: 'Regular exercise or physical activity.',
              VERY_ACTIVE: 'Very Active',
              very_active_descritption: 'Intense exercise or physical job.'
            },
            preferred_languages: 'Preferred Languages',
            diet_preferences: {
              label: 'Dietary Preferences',
              NORMAL: 'NORMAL',
              VEGETARIAN: 'VEGETARIAN',
              VEGAN: 'VEGAN'
            },
            allergens: 'Allergens'
          },
          client_dashboard: {
            today_progress: 'Today progress',
            today_progress_helper: 'See how your current intake compares with today’s plan before choosing the next meal.',
            recommended_meals: 'Recommended meals',
            record_meal: 'Record meal',
            record_first_meal: 'Record first meal',
            what_to_eat_next: 'What to eat next',
            recommended_meals_rationale: 'Based on today’s goals and preferences',
            no_meals_logged: 'No meals yet today',
            quick_record_meal: 'Record meal',
            expand_details: 'Show details',
            collapse_details: 'Hide details',
            record_meal_helper: 'Log your meal below to update your progress',
            how_it_works: 'How does it work?',
            how_it_works_body: 'We compare your current daily progress, targets, and preferences, then recommend meals with adjusted portions so the displayed calories and macros fit your plan more closely.',
            adjustment_box_title: 'Meals are tailored to your goals and activity.',
            adjustment_box_body: 'Click “Adjust composition” to review the current adjusted ingredient amounts used for today’s recommendation.'
          },
          meal: {
            ai_generated: 'AI GENERATED',
            action_save: 'Save',
            action_rate: 'Rate',
            action_share: 'Share',
            action_add_to_plan: 'Add to plan',
            ingredients: 'Ingredients',
            how_to_cook: 'How to cook',
            cooking_mode_on: 'Cooking mode',
            cooking_mode_off: 'Exit cooking mode',
            prev_step: 'Previous',
            next_step: 'Next',
            nutrition_per_serving: 'Nutrition per serving',
            fibre: 'Fibre',
            edit_recipe: 'Edit recipe',
            choose_file: 'Choose file',
            upload: 'Upload',
            rating_empty_cta: 'Be the first to rate',
            rating_summary: '{{average}} / {{count}} ratings',
            rating_user_label: 'You rated this:',
            rating_prompt: 'Rate this meal:',
            adjusted_version_badge: 'Today’s adjusted version',
            adjusted_recipe_note: 'Ingredients and macros reflect today’s adjusted portion. Follow the ingredient list if step text uses generic amounts.'
          },
          common: {
            form: {
              back: 'Back',
              reset: 'Reset form',
              finish: 'Finish',
              next: 'Next'
            },
            nutrient: {
              ENERGY: "Energy",
              PROTEIN: "Protein",
              FAT: "Fat",
              CARBOHYDRATE: "Carbohydrate"
            },
            mealtime: {
              label: 'Mealtime',
              BREAKFAST: 'Breakfast',
              SNACK_AM: 'Snack AM',
              LUNCH: 'Lunch',
              SNACK_PM: 'Snack PM',
              DINNER: 'Dinner'
            },
            sex: {
              label: 'Sex',
              MALE: 'Male',
              FEMALE: 'Female'
            },
            ai_generated_image: 'AI generated image',
            bmi: 'BMI'
          },
          meal_card: {
            view_recipe: 'View recipe',
            hide_recipe: 'Hide recipe'
          },
          navigation: {
            dashboard: 'Dashboard',
            log: 'Log',
            history: 'Meals',
            plan: 'Plan',
            more: 'More',
            help_tips: 'Help & tips',
            feedback: 'Feedback',
            settings: 'Settings'
          },
          feedback: {
            title: 'Feedback',
            subtitle: 'Tell us what works, what is unclear, and what you want improved.',
            text_label: 'Your message',
            text_helper: 'Tell us about bugs, suggestions, questions, or confusion.',
            text_required: 'Please enter a message.',
            submit: 'Send feedback',
            submitting: 'Sending...',
            public: 'Make this feedback public (optional)',
            categories: {
              general: '📌 General',
              bug: '🐞 Bug',
              feature: '💡 Feature request',
              improvement: '✨ Improvement',
              other: '❓ Question'
            },
            success: 'Thanks for your feedback.',
            error: 'Failed to send feedback. Please try again.',
            form_title: 'Send feedback',
            list_title: 'My feedbacks',
            list_loading: 'Loading your feedbacks...',
            list_empty: 'You have no feedback yet.',
            my_feedbacks_title: 'My tickets',
            list_empty_own: 'You have not sent any tickets yet.',
            public_feedbacks_title: 'Public tickets',
            list_empty_public: 'No public tickets yet.',
            list_failed: 'Could not load feedbacks. Try again later.',
            status_open: 'Open',
            status_in_progress: 'In progress',
            status_resolved: 'Resolved',
            status_archived: 'Archived',
            table_headers: {
              date: 'Date',
              category: 'Category',
              status: 'Status',
              public: 'Public',
              text: 'Message'
            },
            yes: 'Yes',
            no: 'No',
          },
          bio_settings: {
            title: 'Bio & goals',
            description: 'Update your bio inputs and goals to refresh your daily calorie and macro targets.',
            bio_section: 'Bio inputs',
            goal_section: 'Goal parameters',
            preview_section: 'Target preview',
            preview_hint: 'Enter weight, height, age, and sex to see live targets.',
            daily_targets: 'Daily targets',
            mealtime_targets: 'Per-meal targets',
            target_date: 'Target date'
          },
          recommended_meal: {
            types: {
              PERFECT_DIET: 'Best fit for today’s goals',
              YOUR_MEAL: 'Your saved meal',
              SAFE_CHOICE: 'Safe choice for your goals',
              VARIETY_PICK: 'Variety pick for balance'
            },
            tags: {
              HIGH_PROTEIN: 'High protein',
              LOW_CALORIE: 'Low kcal',
              BALANCED_MACROS: 'Balanced macros',
              QUICK_PREP: 'Quick prep',
              COMFORT_FOOD: 'Comfort food',
              LIGHT_MEAL: 'Light meal',
              HEAVY_MEAL: 'Hearty meal',
              VEGETARIAN: 'Vegetarian',
              VEGAN: 'Vegan'
            },
            log_now: '✔ Eat now',
            logging: 'Logging...',
            eaten: 'Eaten',
            logged_toast: 'Meal logged',
            logged_failed: 'Failed to log meal',
            adjust_composition: 'Adjust composition',
            adjusted_snapshot: 'The calories and macros shown here already match today’s adjusted portion.',
            composition_preview: 'Today’s composition',
            adjusted_title: 'Your version for today',
            adjusted_subtitle: 'Recipe adjusted for your plan',
            adjusted_explanation: 'The weights below are the adjusted amounts that will be logged if you choose “Eat now”.',
            close: 'Close',
            view_adjusted_recipe: 'View adjusted recipe',
            fit: {
              great: 'Great fit for your plan',
              adjusted: 'Adjusted for today’s goals',
              warning_fat: 'Higher fat share — consider a smaller portion',
              supporting: 'The visible macros belong to the adjusted version you will log.'
            },
            metrics: {
              energy: 'Energy'
            }
          },
          record_meal: {
            title: 'Record meal',
            select_saved_meal: 'Select saved meal',
            search_meals: 'Search meals',
            search_known_meal: 'Search for a known meal',
            saved_meals_title: 'Saved meals',
            search_saved_meals: 'Search saved meals',
            no_saved_meals: 'No saved meals yet',
            unnamed_meal: 'Unnamed meal',
            add_foodstuff_manual: 'Add foodstuff manually',
            compose_manual: 'Build meal manually',
            mode_compose: 'Meal composition',
            cancel_manual: 'Back to saved meals',
            ingredients_heading: 'Meal ingredients',
            ingredient_label: 'Ingredient',
            delete_label: 'Delete',
            increase: 'Increase',
            decrease: 'Decrease',
            consumption_time: 'Consumption time',
            meal_name: 'Meal name',
            weight_grams: 'Weight (g)',
            totals: 'Totals',
            save_meal: 'Save meal',
            prompt: 'What did you eat?',
            prompt_helper: 'Start by searching for a meal or adding ingredients',
            details_heading: 'Meal composition',
            show_details: 'Show details',
            hide_details: 'Hide details',
            empty_state: 'Start by adding food items',
            confirm_switch: 'Switching modes will clear your current selection. Continue?'

          },
          foodstuff_autocomplete: {
            search_foodstuffs: 'Search Foodstuffs',
            type_to_search: 'Type to search...'
          },
          addFoodstuff_addFoodstuff: 'Add foodstuff',
          addFoodstuff_name: 'Name',
          addFoodstuff_density: 'Density',
          addFoodstuff_energy: 'Energy',
          addFoodstuff_protein: 'Protein',
          addFoodstuff_carbohydrate: 'Carbohydrate',
          addFoodstuff_fat: 'Fat',
          addFoodstuff_fiber: 'Fiber',
          addFoodstuff_measurementUnits: 'Measurement units',
          addFoodstuff_add: 'Add',
          add_meal: {
            add_meal: 'Add meal',
            meal_name: 'Name',
            meal_recipe: 'Recipe',
            add_recipe_step: 'Add recipe next recipe step',
            save_public: 'Save meal as public'
          },
          addMeal_addMeal: 'Add meal',
          addMeal_name: 'Name',
          addMeal_receipt: 'Receipt',
          addMeal_mealtime: 'Mealtime',
          addMeal_breakfast: 'Breakfast',
          addMeal_snackAM: 'Snack AM',
          addMeal_lunch: 'Lunch',
          addMeal_snackPM: 'Snack PM',
          addMeal_dinner: 'Dinner',
          addMeal_foodstuff: 'Foodstuff',
          addUser_allergens: 'Allergens',
          trainerDashboard_clients: 'My clients',
          trainerDashboard_meals: 'Meals',
          clients_addClient: 'Add client',
          allergens: {
            GLUTEN: "Gluten",
            SHELLFISH: "Shellfish",
            EGGS: "Eggs",
            FISH: "Fish",
            PEANUTS: "Peanuts",
            SOY: "Soy",
            MILK: "Milk",
            NUTS: "Tree Nuts",
            CELERY: "Celery",
            MUSTARD: "Mustard",
            SESAME: "Sesame",
            SULFITE: "Sulfite",
            LUPINUS: "Lupinus",
            MOLLUSCS: "Molluscs"
          },
          labels: {
            allergies: "Allergies"
          }
        }
      },
      CS: {
        translation: {
          common_name: 'Jméno',
          common_weight: 'Hmotnost',
          common_density: 'Hustota',
          common_energy: 'Energie',
          common_protein: 'Protein',
          common_carbohydrate: 'Sacharidy',
          common_fat: 'Tuk',
          common_fiber: 'Vláknina',
          common_add: 'Přidat',
          common_save: 'Uložit',
          login: {
            welcome_message_heading: 'Vítejte! Naplánujte si jídla snadno',
            welcome_message_description: 'Stanovte si cíle, sledujte jejich plnění a užívejte si recepty přizpůsobené vašim preferencím a životnímu stylu. Získejte užitečné tipy, skvělé recepty a vždy správně spočítané porce jídel – začněte hned teď!',
            username: 'Uživatelské jméno',
            password: 'Heslo',
            login: 'Přihlásit se',
            start_onboarding: 'Vytvořit plán',
            newsletter: 'Zadejte svůj e-mail pro odběr novinek'
          },
          onboarding_dashboard: {
            header: 'Vítejte na svém personalizovaném panelu',
            subheader: 'Na základě vašich údajů jsme vypočítali tyto denní cíle, které vám pomohou dosáhnout vašeho cílového BMI.',
            primary_cta: 'Podívat se na doporučená jídla',
            health_overview: {
              label: 'Přehled zdraví',
              bmi: 'BMI',
              goal: 'Cíl',
              daily_calories: 'Denní kalorie',
              weight: 'Aktuální hmotnost'
            },
            motivational_message: 'Jste na dobré cestě k dosažení svých zdravotních cílů!',
            cta_message: 'Chcete uložit svůj personalizovaný plán a sledovat svůj pokrok?',
            nutritional_goals: 'Nutriční cíle',
            recommended_meals: {
              label: 'Doporučená jídla',
              header: 'Tato jídla byla pečlivě vypočítána tak, aby splňovala vaše denní cíle.'
            }
          },
          signup_section: {
            your_email: 'Vaše emailová adresa',
            password: {
              password: 'Heslo',
              password_strength: 'Síla hesla',
              very_weak: 'Velmi slabé',
              weak: 'Slabé',
              medium: 'Střední',
              strong: 'Silné',
              very_strong: 'Velmi silné',
            },
            submitting: 'Odesílání...',
            save_my_progress: 'Uložit můj pokrok'
          },
          onboarding: {
            stepper: {
              STEP1: 'Tělesné údaje',
              STEP2: 'Životní styl',
              STEP3: 'Preference'
            },
            tooltip: {
              sex: 'Vaše biologické pohlaví nám pomáhá poskytovat přesnější odhady kalorických potřeb přizpůsobené vašim potřebám. Vyberte prosím možnost, která nejlépe odpovídá vašemu biologickému pohlaví.',
              preferred_languages: 'Priorita je důležitá; první vybraná možnost má nejvyšší prioritu, a tak dále.'
            },
            step1_helper: 'Tyto údaje používáme k výpočtu denního příjmu a porcí. Můžete je kdykoli změnit.',
            step1_motivation: 'Pomůžeme vám dosáhnout cílové váhy zdravým tempem.',
            step1_weight_change_limit_exceeded: "Změna váhy mezi současnou a cílovou nesmí překročit 10 kg.",
            target_date: 'Kdy chcete cíle dosáhnout?',
            current_bmi: 'Aktuální BMI',
            target_bmi: 'Cílové BMI',
            step1_target_date_past_error: 'Zadané datum je v minulosti.',
            unhealthy_pace_warning: 'S tímto termínem byste museli hubnout více než 0.75 kg týdně, což bývá dlouhodobě špatně udržitelné. Doporučujeme cílové datum {{recommendedDate}}.',
            use_recommended_target_date: 'Použít doporučené datum',
            validation_required: 'Vyplňte všechna pole.',
            current_weight: 'Současná váha (kg)',
            target_weight: 'Cílová váha (kg)',
            height: 'Výška (cm)',
            age: 'Věk',
            activity_level: {
              label: 'Stupeň aktivity',
              SEDENTARY: 'Sedavý',
              sedentary_descritption: 'Minimální pohyb během dne',
              MODERATELY_ACTIVE: 'Středně aktivní',
              moderately_active_descritption: 'Pravidelný pohyb nebo fyzická aktivita',
              VERY_ACTIVE: 'Velmi aktivní',
              very_active_descritption: 'Intenzivní trénink nebo fyzická práce.'
            },
            preferred_languages: 'Preferované jazyky',
            diet_preferences: {
              label: 'Dietní preference',
              NORMAL: 'NORMÁLNÍ',
              VEGETARIAN: 'VEGETARIÁN',
              VEGAN: 'VEGAN'
            },
            allergens: 'Alergeny'
          },
          client_dashboard: {
            today_progress: 'Dnešní progress',
            today_progress_helper: 'Rychle uvidíš, kolik už máš splněno a jak další jídlo zapadne do dnešního plánu.',
            recommended_meals: 'Doporučené jídla',
            record_meal: 'Zaznamenat jídlo',
            record_first_meal: 'Zaznamenat první jídlo',
            what_to_eat_next: 'Co jíst dál',
            recommended_meals_rationale: 'Na základě dnešních cílů a preferencí',
            no_meals_logged: 'Zatím žádné jídlo dnes',
            quick_record_meal: 'Zaznamenat jídlo',
            expand_details: 'Rozbalit detaily',
            collapse_details: 'Skrýt detaily',
            record_meal_helper: 'Zaznamenej jídlo níže a aktualizuj svůj progress',
            how_it_works: 'Jak to funguje?',
            how_it_works_body: 'Sledujeme tvůj dnešní progress, cíle a preference a podle toho doporučíme jídla s upravenými porcemi, aby zobrazené kalorie a makra co nejlépe odpovídaly tvému plánu.',
            adjustment_box_title: 'Jídla jsou přizpůsobena tvým cílům a aktivitě.',
            adjustment_box_body: 'Kliknutím na „Upravit složení“ zobrazíš dnešní upravené poměry surovin, které se také odešlou při „Sníst teď“.'
          },
          meal: {
            ai_generated: 'GENEROVÁNO AI',
            action_save: 'Uložit',
            action_rate: 'Ohodnotit',
            action_share: 'Sdílet',
            action_add_to_plan: 'Přidat do plánu',
            ingredients: 'Suroviny',
            how_to_cook: 'Jak vařit',
            cooking_mode_on: 'Režim vaření',
            cooking_mode_off: 'Ukončit režim',
            prev_step: 'Předchozí',
            next_step: 'Další',
            nutrition_per_serving: 'Nutriční hodnoty na porci',
            fibre: 'Vláknina',
            edit_recipe: 'Upravit recept',
            choose_file: 'Vybrat soubor',
            upload: 'Nahrát',
            rating_empty_cta: 'Buďte první, kdo ohodnotí',
            rating_summary: '{{average}} / {{count}} hodnocení',
            rating_user_label: 'Ohodnotili jste:',
            rating_prompt: 'Ohodnotit jídlo:',
            adjusted_version_badge: 'Dnešní upravená verze',
            adjusted_recipe_note: 'Suroviny a makra odpovídají dnešní upravené porci. Pokud je v postupu obecná gramáž, řiď se seznamem surovin výše.'
          },
          common: {
            form: {
              back: 'Zpět',
              reset: 'Vymazat',
              finish: 'Dokončit',
              next: 'Další'
            },
            nutrient: {
              ENERGY: "Energie",
              PROTEIN: "Protein",
              FAT: "Tuk",
              CARBOHYDRATE: "Sacharidy"
            },
            sex: {
              label: 'Pohlaví',
              MALE: 'Muž',
              FEMALE: 'Žena'
            },
            mealtime: {
              label: 'Čas jídla',
              BREAKFAST: 'Snídaně',
              SNACK_AM: 'Dopolední svačina',
              LUNCH: 'Oběd',
              SNACK_PM: 'Odpolední svačina',
              DINNER: 'Večeře'
            },
            ai_generated_image: 'obrázek vytvořen pomocí AI',
            bmi: 'BMI'
          },
          meal_card: {
            view_recipe: 'Zobraz recept',
            hide_recipe: 'Skryj recept'
          },
          navigation: {
            dashboard: 'Přehled',
            log: 'Záznam',
            history: 'Jídla',
            plan: 'Plán',
            more: 'Další',
            help_tips: 'Nápověda',
            feedback: 'Feedback',
            settings: 'Nastavení'
          },
          feedback: {
            title: 'Zpětná vazba',
            subtitle: 'Jste mezi prvními uživateli aplikace. Vaše zpětná vazba přímo ovlivní, jak bude produkt vypadat v dalších verzích.',
            text_label: 'Zpráva',
            text_helper: 'Můžete nahlásit chybu, navrhnout funkci nebo se podělit o nápad.',
            text_required: 'Zadejte prosím text zpětné vazby.',
            submit: 'Odeslat zpětnou vazbu',
            submitting: 'Odesílám…',
            public: 'Zveřejnit tuto zprávu (volitelné)',
            categories: {
              general: '📌 Obecné',
              bug: '🐞 Chyba',
              feature: '💡 Nápad',
              improvement: '✨ Zlepšení',
              other: '❓ Otázka'
            },
            success: 'Děkujeme za vaši zpětnou vazbu.',
            error: 'Nepodařilo se odeslat zpětnou vazbu. Zkuste to prosím znovu.',
            form_title: 'Odeslat zpětnou vazbu',
            list_title: 'Moje zpětné vazby',
            list_loading: 'Načítám vaši zpětnou vazbu...',
            list_empty: 'Zatím nemáte žádnou zpětnou vazbu.',
            my_feedbacks_title: 'Moje zpětné zprávy',
            list_empty_own: 'Zatím jste nevytvořili žádný záznam.',
            public_feedbacks_title: 'Veřejné zprávy',
            list_empty_public: 'Žádné veřejné zprávy.',
            list_failed: 'Nepodařilo se načíst zpětnou vazbu. Zkuste to prosím znovu.',
            status_open: 'Otevřeno',
            status_in_progress: 'Ve zpracování',
            status_resolved: 'Vyřešeno',
            status_archived: 'Archivováno',
            table_headers: {
              date: 'Datum',
              category: 'Kategorie',
              status: 'Stav',
              public: 'Veřejné',
              text: 'Zpráva'
            },
            yes: 'Ano',
            no: 'Ne',
          },
          bio_settings: {
            title: 'Bio a cíle',
            description: 'Upravte své bio údaje a cíle pro přepočet denních kalorií a makroživin.',
            bio_section: 'Bio údaje',
            goal_section: 'Parametry cíle',
            preview_section: 'Náhled cílů',
            preview_hint: 'Zadejte váhu, výšku, věk a pohlaví pro živý přepočet.',
            daily_targets: 'Denní cíle',
            mealtime_targets: 'Cíle na jídlo',
            target_date: 'Cílové datum'
          },
          recommended_meal: {
            types: {
              PERFECT_DIET: 'Nejlepší volba pro dnešní cíle',
              YOUR_MEAL: 'Vaše uložené jídlo',
              SAFE_CHOICE: 'Bezpečná volba pro vaše cíle',
              VARIETY_PICK: 'Pestrá volba pro rovnováhu'
            },
            tags: {
              HIGH_PROTEIN: 'Vysoký obsah bílkovin',
              LOW_CALORIE: 'Nízké kcal',
              BALANCED_MACROS: 'Vyvážené makroživiny',
              QUICK_PREP: 'Rychlá příprava',
              COMFORT_FOOD: 'Jídlo pro pohodu',
              LIGHT_MEAL: 'Lehké jídlo',
              HEAVY_MEAL: 'Vydatné jídlo',
              VEGETARIAN: 'Vegetariánské',
              VEGAN: 'Veganské'
            },
            log_now: '✔ Sníst teď',
            logging: 'Ukládám...',
            eaten: 'Snědeno',
            logged_toast: 'Jídlo zaznamenáno',
            logged_failed: 'Nepodařilo se zaznamenat jídlo',
            adjust_composition: 'Upravit složení',
            adjusted_snapshot: 'Zobrazené kalorie i makra už odpovídají dnešní upravené porci.',
            composition_preview: 'Dnešní složení',
            adjusted_title: 'Tvoje dnešní verze',
            adjusted_subtitle: 'Recept upraven pro tvůj plán',
            adjusted_explanation: 'Níže vidíš upravené gramáže, které se odešlou i při kliknutí na „Sníst teď“.',
            close: 'Zavřít',
            view_adjusted_recipe: 'Zobrazit upravený recept',
            fit: {
              great: 'Skvěle sedí do tvého plánu',
              adjusted: 'Upraveno pro dnešní cíle',
              warning_fat: 'Vyšší podíl tuku — zvaž menší porci',
              supporting: 'Zobrazené makroživiny patří k upravené verzi, kterou také zaznamenáš.'
            },
            metrics: {
              energy: 'Energie'
            }
          },
          record_meal: {
            title: 'Zaznamenat jídlo',
            select_saved_meal: 'Vybrat uložené jídlo',
            search_meals: 'Vyhledat jídlo',
            search_known_meal: 'Vyhledat uložené jídlo',
            saved_meals_title: 'Uložená jídla',
            search_saved_meals: 'Vyhledat uložená jídla',
            no_saved_meals: 'Zatím nemáte uložená jídla',
            unnamed_meal: 'Jídlo bez názvu',
            add_foodstuff_manual: 'Přidat potravinu',
            compose_manual: 'Sestavit jídlo ručně',
            mode_compose: 'Sestavení jídla',
            cancel_manual: 'Zpět na uložená jídla',
            ingredients_heading: 'Složení jídla',
            ingredient_label: 'Potravina',
            delete_label: 'Smazat',
            increase: 'Zvýšit',
            decrease: 'Snížit',
            consumption_time: 'Čas konzumace',
            meal_name: 'Název jídla',
            weight_grams: 'Váha (g)',
            totals: 'Celkem',
            save_meal: 'Uložit jídlo',
            prompt: 'Co jste jedli?',
            prompt_helper: 'Začněte vyhledáním jídla nebo přidáním potravin',
            details_heading: 'Složení jídla',
            show_details: 'Zobrazit detaily',
            hide_details: 'Skrýt detaily',
            empty_state: 'Začněte přidáním potravin',
            confirm_switch: 'Přepnutím režimu se smaže aktuální výběr. Pokračovat?'
          },
          foodstuff_autocomplete: {
            search_foodstuffs: 'Vyhledávání potravin',
            type_to_search: 'Vyhledat...'
          },
          addFoodstuff_addFoodstuff: 'Přidat potravinu',
          addFoodstuff_name: 'Jméno',
          addFoodstuff_density: 'Hustota',
          addFoodstuff_energy: 'Energie',
          addFoodstuff_protein: 'Protein',
          addFoodstuff_carbohydrate: 'Sacharidy',
          addFoodstuff_fat: 'Tuk',
          addFoodstuff_fiber: 'Vláknina',
          addFoodstuff_measurementUnits: 'Odměrné jednotky',
          addFoodstuff_add: 'Přidat',
          add_meal: {
            add_meal: 'Přidat jídlo',
            meal_name: 'Název',
            meal_recipe: 'Recept',
            add_recipe_step: 'Přidat další krok receptu',
            save_public: 'Uložit jídlo jako veřejné'
          },
          addMeal_addMeal: 'Přidat jídlo',
          addMeal_name: 'Název',
          addMeal_receipt: 'Recept',
          addMeal_mealtime: 'Doba jídla',
          addMeal_breakfast: 'Snídaně',
          addMeal_snackAM: 'Dopolední svačina',
          addMeal_lunch: 'Oběd',
          addMeal_snackPM: 'Odpolední svačina',
          addMeal_dinner: 'Večeře',
          addMeal_foodstuff: 'Potravina',
          trainerDashboard_clients: 'Moji klienti',
          trainerDashboard_meals: 'Jídla',
          clients_addClient: 'Přidat klienta',
          allergens: {
            GLUTEN: "Lepek",
            SHELLFISH: "Korýši",
            EGGS: "Vejce",
            FISH: "Ryby",
            PEANUTS: "Podzemnice",
            SOY: "Sójové boby",
            MILK: "Mléko",
            NUTS: "Ořechy",
            CELERY: "Celer",
            MUSTARD: "Hořčice",
            SESAME: "Sezam",
            SULFITE: "Oxid siřičitý",
            LUPINUS: "Vlčí bob",
            MOLLUSCS: "Měkkýši"
          },
          labels: {
            allergies: "Alergeny"
          }
        }
      },
      SK: {
        translation: {
          common_name: 'Názov',
          common_weight: 'Hmotnosť',
          common_density: 'Hustota',
          common_energy: 'Energia',
          common_protein: 'Protein',
          common_carbohydrate: 'Sacharidy',
          common_fat: 'Tuky',
          common_fiber: 'Vláknina',
          common_add: 'Pridať',
          common_save: 'Uložiť',
          login: {
            welcome_message_heading: 'Vitajte! Naplánujte si jedlá jednoducho',
            welcome_message_description: 'Stanovte si ciele, sledujte ich dosahovanie a užívajte si recepty prispôsobené vašim preferenciám a životnému štýlu. Získajte užitočné tipy, chutné recepty a okamžité plány jedál – začnite ešte dnes!',
            username: 'Používateľské meno',
            password: 'Heslo',
            login: 'Prihlásiť sa',
            start_onboarding: 'Vytvoriť plán',
            newsletter: 'Zadajte svoj e-mail a začnite'
          },
          onboarding_dashboard: {
            header: 'Vitajte na vašom personalizovanom paneli',
            subheader: 'Na základe vašich údajov sme vypočítali tieto denné ciele, aby sme vám pomohli dosiahnuť váš cieľový BMI.',
            primary_cta: 'Pozrieť odporúčané jedlá',
            health_overview: {
              label: 'Prehľad zdravia',
              bmi: 'BMI',
              goal: 'Cieľ',
              daily_calories: 'Denné kalórie',
              weight: 'Aktuálna hmotnosť'
            },
            motivational_message: 'Ste na dobrej ceste k dosiahnutiu svojich zdravotných cieľov!',
            cta_message: 'Chcete si uložiť svoj personalizovaný plán a sledovať svoj pokrok?',
            nutritional_goals: 'Nutričné ciele',
            recommended_meals: {
              label: 'Odporúčané jedlá',
              header: 'Tieto jedlá boli starostlivo vypočítané tak, aby splnili vaše denné ciele.'
            }
          },
          signup_section: {
            your_email: 'Vaša emailová adresa',
            password: {
              password: 'Heslo',
              password_strength: 'Sila hesla',
              very_weak: 'Veľmi slabé',
              weak: 'Slabé',
              medium: 'Stredné',
              strong: 'Silné',
              very_strong: 'Veľmi silné',
            },
            submitting: 'Odosielanie...',
            save_my_progress: 'Uložiť môj pokrok'
          },
          onboarding: {
            stepper: {
              STEP1: 'Telesné údaje',
              STEP2: 'Životný štýl',
              STEP3: 'Preferencie'
            },
            tooltip: {
              sex: 'Vaše biologické pohlavie nám pomáha poskytovať presnejšie odhady kalorických potrieb prispôsobené vašim potrebám. Prosím, vyberte možnosť, ktorá najlepšie zodpovedá vášmu biologickému pohlaviu.',
              preferred_languages: 'Priorita je dôležitá; prvá vybraná možnosť má najvyššiu prioritu, a tak ďalej.“'
            },
            step1_helper: 'Tieto údaje používame na výpočet denného príjmu a porcií. Môžete ich kedykoľvek zmeniť.',
            step1_weight_change_limit_exceeded: "Zmena váhy medzi súčasnou a cieľovou hmotnosťou nemôže presiahnuť 10 kg.",
            target_date: 'Kedy chcete ciele dosiahnuť?',
            current_bmi: 'Aktuálne BMI',
            target_bmi: 'Cieľové BMI',
            step1_target_date_past_error: 'Zadaný termín je v minulosti.',
            unhealthy_pace_warning: 'S týmto termínom by ste museli chudnúť viac než 0.75 kg týždenne, čo býva ťažko udržateľné. Odporúčame cieľové dátum {{recommendedDate}}.',
            use_recommended_target_date: 'Použiť odporúčané dátum',
            step1_motivation: 'Pomôžeme vám dosiahnuť cieľovú váhu zdravým tempom.',
            validation_required: 'Vyplňte všetky polia.',
            current_weight: 'Súčasná vaha (kg)',
            target_weight: 'Cílová váha (kg)',
            height: 'Výška (cm)',
            age: 'Vek',
            activity_level: {
              label: 'Stupeň aktivity',
              SEDENTARY: 'Sedavý',
              sedentary_descritption: 'Minimální denný pohyb',
              MODERATELY_ACTIVE: 'Primerano aktivný',
              moderately_active_descritption: 'Pravidelné cvičenie nebo fyzická aktivita.',
              VERY_ACTIVE: 'Very Active',
              very_active_descritption: 'Intense exercise or physical job.'
            },
            preferred_languages: 'Preferované jazyky',
            diet_preferences: {
              label: 'Dietné preferencie',
              NORMAL: 'NORMÁLNÉ',
              VEGETARIAN: 'VEGETARIÁN',
              VEGAN: 'VEGAN'
            },
            allergens: 'Allergeny'
          },
          client_dashboard: {
            today_progress: 'Dnešný progress',
            today_progress_helper: 'Rýchlo uvidíš, koľko už máš splnené a ako ďalšie jedlo zapadne do dnešného plánu.',
            recommended_meals: 'Doporučená jedlá',
            record_meal: 'Zaznamenat jedlo',
            record_first_meal: 'Zaznamenat prvé jedlo',
            what_to_eat_next: 'Čo jesť ďalej',
            recommended_meals_rationale: 'Na základe dnešných cieľov a preferencií',
            no_meals_logged: 'Zatiaľ žiadne jedlo dnes',
            quick_record_meal: 'Zaznamenat jedlo',
            expand_details: 'Rozbaliť detaily',
            collapse_details: 'Skryť detaily',
            record_meal_helper: 'Zaznamenaj jedlo nižšie a aktualizuj svoj progress',
            how_it_works: 'Ako to funguje?',
            how_it_works_body: 'Sledujeme tvoj dnešný progress, ciele a preferencie a podľa toho odporučíme jedlá s upravenými porciami, aby zobrazené kalórie a makrá čo najlepšie sedeli do tvojho plánu.',
            adjustment_box_title: 'Jedlá sú prispôsobené tvojim cieľom a aktivite.',
            adjustment_box_body: 'Kliknutím na „Upraviť zloženie“ zobrazíš dnešné upravené pomery surovín, ktoré sa odošlú aj pri „Zjesť teraz“.'
          },
          meal: {
            ai_generated: 'GENEROVANÉ AI',
            action_save: 'Uložiť',
            action_rate: 'Ohodnotiť',
            action_share: 'Zdieľať',
            action_add_to_plan: 'Pridať do plánu',
            ingredients: 'Suroviny',
            how_to_cook: 'Ako variť',
            cooking_mode_on: 'Režim varenia',
            cooking_mode_off: 'Ukončiť režim',
            prev_step: 'Predchádzajúci',
            next_step: 'Ďalší',
            nutrition_per_serving: 'Nutričné hodnoty na porciu',
            fibre: 'Vláknina',
            edit_recipe: 'Upraviť recept',
            choose_file: 'Vybrať súbor',
            upload: 'Nahrať',
            rating_empty_cta: 'Buďte prvý, kto ohodnotí',
            rating_summary: '{{average}} / {{count}} hodnotení',
            rating_user_label: 'Ohodnotili ste:',
            rating_prompt: 'Ohodnotiť jedlo:',
            adjusted_version_badge: 'Dnešná upravená verzia',
            adjusted_recipe_note: 'Suroviny aj makrá zodpovedajú dnešnej upravenej porcii. Ak je v postupe všeobecná gramáž, riaď sa zoznamom surovín vyššie.'
          },
          common: {
            form: {
              back: 'Zpet',
              reset: 'Zmazat formulár',
              finish: 'Dokončit',
              next: 'Dále'
            },
            nutrient: {
              ENERGY: "Energia",
              PROTEIN: "Protein",
              FAT: "Tuk",
              CARBOHYDRATE: "Cukry"
            },
            sex: {
              label: 'Pohlavie',
              MALE: 'Muž',
              FEMALE: 'Žena'
            },
            mealtime: {
              label: 'Čas jedla',
              BREAKFAST: 'Raňajky',
              SNACK_AM: 'Desiatá',
              LUNCH: 'Obed',
              SNACK_PM: 'Olovrant',
              DINNER: 'Večera'
            },
            ai_generated_image: 'obrázok vytvoren s pomocou AI',
            bmi: 'BMI'
          },
          meal_card: {
            view_recipe: 'Zobraz recept',
            hide_recipe: 'Skryj recept'
          },
          navigation: {
            dashboard: 'Prehľad',
            log: 'Záznam',
            history: 'Jedlá',
            plan: 'Plán',
            more: 'Viac',
            help_tips: 'Nápověda',
            feedback: 'Feedback',
            settings: 'Nastavenia'
          },
          feedback: {
            title: 'Spätná väzba',
            subtitle: 'Povedzte nám, čo by sme mali zlepšiť, opraviť alebo doplniť.',
            text_label: 'Správa',
            text_helper: 'Môžete nahlásiť chybu, navrhnúť funkciu alebo sa podeliť o nápad.',
            text_required: 'Zadajte prosím text spätnej väzby.',
            submit: 'Odoslať spätnú väzbu',
            submitting: 'Odosielam...',
            public: 'Zverejniť túto správu (voliteľné)',
            categories: {
              general: '📌 Všeobecné',
              bug: '🐞 Chyba',
              feature: '💡 Nápad',
              improvement: '✨ Zlepšenie',
              other: '❓ Otázka'
            },
            success: 'Ďakujeme za vašu spätnú väzbu.',
            error: 'Nepodarilo sa odoslať spätnú väzbu. Skúste to prosím znova.',
            form_title: 'Odoslať spätnú väzbu',
            list_title: 'Moja spätná väzba',
            list_loading: 'Načítavam vašu spätnú väzbu...',
            list_empty: 'Zatiaľ nemáte žiadnu spätnú väzbu.',
            my_feedbacks_title: 'Moje spätá spätná väzba',
            list_empty_own: 'Zatiaľ ste neposlali žiadnu spätnú väzbu.',
            public_feedbacks_title: 'Verejné správy',
            list_empty_public: 'Zatiaľ žiadne verejné správy.',
            list_failed: 'Nepodarilo sa načítať spätnú väzbu. Skúste to prosím znova.',
            status_open: 'Otvorená',
            status_in_progress: 'V spracovaní',
            status_resolved: 'Vyriešené',
            status_archived: 'Archivované',
            table_headers: {
              date: 'Dátum',
              category: 'Kategória',
              status: 'Stav',
              public: 'Verejné',
              text: 'Správa'
            },
            yes: 'Áno',
            no: 'Nie',
          },
          bio_settings: {
            title: 'Bio a ciele',
            description: 'Upravte svoje bio údaje a ciele pre prepočet denných kalórií a makier.',
            bio_section: 'Bio údaje',
            goal_section: 'Parametre cieľa',
            preview_section: 'Náhľad cieľov',
            preview_hint: 'Zadajte váhu, výšku, vek a pohlavie pre živý prepočet.',
            daily_targets: 'Denné ciele',
            mealtime_targets: 'Ciele na jedlo',
            target_date: 'Cieľový dátum'
          },
          recommended_meal: {
            types: {
              PERFECT_DIET: 'Najlepšia voľba pre dnešné ciele',
              YOUR_MEAL: 'Vaše uložené jedlo',
              SAFE_CHOICE: 'Bezpečná voľba pre vaše ciele',
              VARIETY_PICK: 'Pestrá voľba pre rovnováhu'
            },
            tags: {
              HIGH_PROTEIN: 'Vysoký obsah bielkovín',
              LOW_CALORIE: 'Nízke kcal',
              BALANCED_MACROS: 'Vyvážené makrá',
              QUICK_PREP: 'Rýchla príprava',
              COMFORT_FOOD: 'Jedlo pre pohodu',
              LIGHT_MEAL: 'Ľahké jedlo',
              HEAVY_MEAL: 'Výdatné jedlo',
              VEGETARIAN: 'Vegetariánske',
              VEGAN: 'Vegánske'
            },
            log_now: '✔ Zjesť teraz',
            logging: 'Ukladám...',
            eaten: 'Zjedené',
            logged_toast: 'Jedlo zaznamenané',
            logged_failed: 'Nepodarilo sa zaznamenať jedlo',
            adjust_composition: 'Upraviť zloženie',
            adjusted_snapshot: 'Zobrazené kalórie aj makrá už zodpovedajú dnešnej upravenej porcii.',
            composition_preview: 'Dnešné zloženie',
            adjusted_title: 'Tvoja dnešná verzia',
            adjusted_subtitle: 'Recept upravený pre tvoj plán',
            adjusted_explanation: 'Nižšie vidíš upravené gramáže, ktoré sa odošlú aj pri kliknutí na „Zjesť teraz“.',
            close: 'Zavrieť',
            view_adjusted_recipe: 'Zobraziť upravený recept',
            fit: {
              great: 'Skvele sedí do tvojho plánu',
              adjusted: 'Upravené pre dnešné ciele',
              warning_fat: 'Vyšší podiel tuku — zváž menšiu porciu',
              supporting: 'Zobrazené makrá patria k upravenej verzii, ktorú aj zaznamenáš.'
            },
            metrics: {
              energy: 'Energia'
            }
          },
          record_meal: {
            title: 'Zaznamenať jedlo',
            select_saved_meal: 'Vybrať uložené jedlo',
            search_meals: 'Vyhledat jedlo',
            search_known_meal: 'Vyhledat uložené jedlo',
            saved_meals_title: 'Uložené jedlá',
            search_saved_meals: 'Vyhľadať uložené jedlá',
            no_saved_meals: 'Zatiaľ nemáte uložené jedlá',
            unnamed_meal: 'Jedlo bez názvu',
            add_foodstuff_manual: 'Pridať potravinu',
            compose_manual: 'Zostaviť jedlo ručne',
            mode_compose: 'Zostavenie jedla',
            cancel_manual: 'Späť na uložené jedlá',
            ingredients_heading: 'Zloženie jedla',
            ingredient_label: 'Potravina',
            delete_label: 'Vymazať',
            increase: 'Zvýšiť',
            decrease: 'Znížiť',
            consumption_time: 'Čas konzumácie',
            meal_name: 'Názov jedla',
            weight_grams: 'Váha (g)',
            totals: 'Celkom',
            save_meal: 'Uložit jedlo',
            prompt: 'Čo ste jedli?',
            prompt_helper: 'Začnite vyhľadaním jedla alebo pridaním potravín',
            details_heading: 'Zloženie jedla',
            show_details: 'Zobraziť detaily',
            hide_details: 'Skryť detaily',
            empty_state: 'Začnite pridaním potravín',
            confirm_switch: 'Prepnutím režimu sa vymaže aktuálny výber. Pokračovať?'
          },
          foodstuff_autocomplete: {
            search_foodstuffs: 'Vyhledat potravinu',
            type_to_search: 'Vyhledat...'
          },
          addFoodstuff_addFoodstuff: 'Pridať potravinu',
          addFoodstuff_name: 'Názov',
          addFoodstuff_density: 'Hustota',
          addFoodstuff_energy: 'Energia',
          addFoodstuff_protein: 'Protein',
          addFoodstuff_carbohydrate: 'Sacharidy',
          addFoodstuff_fat: 'Tuky',
          addFoodstuff_fiber: 'Vláknina',
          addFoodstuff_measurementUnits: 'Odmerné jednotky',
          addFoodstuff_add: 'Pridať',
          add_meal: {
            add_meal: 'Pridať jedlo',
            meal_name: 'Názov',
            meal_recipe: 'Recept',
            add_recipe_step: 'Pridat další krok receptu',
            save_public: 'Uložit jedlo verejno'
          },
          addMeal_addMeal: 'Pridať jedlo',
          addMeal_name: 'Názov',
          addMeal_receipt: 'Recept',
          addMeal_mealtime: 'Typ jedla',
          addMeal_breakfast: 'Raňajky',
          addMeal_snackAM: 'Desiata',
          addMeal_lunch: 'Obed',
          addMeal_snackPM: 'Olovrant',
          addMeal_dinner: 'Večera',
          addMeal_foodstuff: 'Potravina',
          trainerDashboard_clients: 'Moji klenti',
          trainerDashboard_meals: 'Jedla',
          clients_addClient: 'Pridat klienta',
          allergens: {
            GLUTEN: "Glutén",
            SHELLFISH: "Kôrovce",
            EGGS: "Vajcia",
            FISH: "Ryby",
            PEANUTS: "Arašidy",
            SOY: "Sója",
            MILK: "Mlieko",
            NUTS: "Orechy",
            CELERY: "Zeler",
            MUSTARD: "Horčica",
            SESAME: "Sezam",
            SULFITE: "Siričitany",
            LUPINUS: "Lupina",
            MOLLUSCS: "Mäkkýše"
          },
          labels: {
            allergies: "Alergie"
          }
        }
      }
    }
  });

export default i18n;
